import { ApiInstance } from '../..';

export const updateOrganizationName = (name: string) =>
    ApiInstance.getInstance().put('/api/organizations/current', { name });

export const getOrganizationMembers = () =>
    ApiInstance.getInstance().get<{
        members: Array<{
            userId: number;
            username: string;
            email: string;
            role: string;
            joinedAt: string;
        }>;
        pendingInvites: Array<{
            organizationInviteId: number;
            email: string;
            role: string;
            expiresAt: string;
            createdAt: string;
        }>;
    }>('/api/organizations/members');

export const inviteOrganizationMember = (email: string) =>
    ApiInstance.getInstance().post('/api/organizations/invites', { email });

export const revokeOrganizationInvite = (inviteId: number) =>
    ApiInstance.getInstance().delete(`/api/organizations/invites/${inviteId}`);

export const removeOrganizationMember = (userId: number) =>
    ApiInstance.getInstance().delete(`/api/organizations/members/${userId}`);
